import { render, staticRenderFns } from "./postinfo.vue?vue&type=template&id=2d43bdb4&scoped=true&"
import script from "./postinfo.vue?vue&type=script&lang=js&"
export * from "./postinfo.vue?vue&type=script&lang=js&"
import style0 from "./postinfo.vue?vue&type=style&index=0&id=2d43bdb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43bdb4",
  null
  
)

export default component.exports